import React, { useState } from "react";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { BiX } from "react-icons/bi";

export default function DeleteTriviaPopup({
  onClose,
  open,
  item,
  onDeleteItem,
  isLibrary,
  type,
  isMessaging
}) {
  const handleDelete = () => {
    axios
      .delete(url.deleteTrivia(item._id))
      .then(data => {
        onDeleteItem(item._id);
      })
      .catch(err => {
        console.log(err);
      });
  };
  return (
    <Modal isOpen={open} size="sm" centered>
      <ModalHeader
      className={type==="DELETE"?"trivia_modal_header_bg_delete":"trivia_modal_header_bg"}
        close={
          <BiX
            className="cursor-pointer"
            color="gray"
            size={30}
            onClick={() => onClose()}
          />
        }
      >
        Delete this {isLibrary ? "Resource?" : "Trivvy?"}
      </ModalHeader>

      <ModalBody className="p-3">
        <div className="mt-3">
          <p>
            You're about to delete <b>{item.name}</b>.
          </p>
          <p>
            Are you sure you want to Delete this{" "}
            {isLibrary ? "library" : isMessaging ? "message": "Trivvy"} ?
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className="trivia-action-button-secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={() => (isLibrary ? onDeleteItem() : handleDelete())}
          color='danger'
        >
          Yes Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
}
